<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('assign_service_to') }} {{ category.name }}
      v-spacer
      v-btn(icon @click="hideDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-text-field.round-xl.text-md.px-6.pt-6(v-if="!showNoServices" :placeholder="$t('search_service')" v-model="searchText" @input="queryChanged" outlined hide-details)
      template(v-slot:prepend-inner)
        v-icon.mx-1(size=20) $yzi-search-sm
    v-card-text.primary--text.px-8.py-2
      .text-center.my-8(v-if="isFetching")
        v-progress-circular(width="2" size="30" color="primary" indeterminate)
      template(v-else)
        .text-center.my-16(v-if="showNoServices")
          v-avatar.mb-8(color="neutral300" size="54" rounded="circle")
            v-icon(color="neutral500" size="36") $yzi-medical-cross
          .mb-1.font-semibold.text-md {{ $t('empty_services') }}
          .text-sm.neutral500--text {{ $t('empty_services_category_desc') }}

        template(v-else)
          .text-center.py-8.neutral500--text(v-if="!services.length") {{ $t('no_service_found') }}
          template(v-else)
            div(v-for="(service, index) in services")
              v-row(align="center")
                v-col(cols="1")
                  yc-checkbox(v-model="selectedServices" :value="service.product.id")
                v-col(cols="7")
                  .text-left.font-medium.text-sm {{ service.name }}
                v-col.text-xs.neutral500--text(cols="4")
                  div {{ $t('booking_fee') }}: {{ service.booking_fee | displayPrice($currency) }}
                  div {{ $t('duration') }}: {{ service.duration_value }} {{ service.duration_unit }}
              v-divider(v-if="index !== services.length - 1")
            .pb-16
    v-divider

    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="hideDialog" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(v-if="showNoServices" @click="createService" color="primary" depressed :disabled="isLoading") {{ $t('create_service') }}
      v-btn.button-md(v-else @click="confirm" :loading="isLoading" color="primary" depressed :disabled="!selectedServices.length") {{ $t('confirm') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'

export default {
  name: 'AssignCategoryServicesDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    category: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    isLoading: false,
    isFetching: false,
    services: [],
    selectedServices: [],
    searchText: ''
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    showNoServices () {
      return this.services.length === 0 && !this.searchText && !this.isLoading
    }
  },
  mounted () {
    this.fetchCategory()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCategory () {
      this.isFetching = true
      this.$axios.get(`/product_categories/${this.category.id}/products?page_size=-1`)
        .then(resp => {
          const results = resp?.data.results
          if (results) {
            this.selectedServices = results.map(item => item.id)
          }
          this.fetchServices()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    fetchServices () {
      this.isFetching = true
      const params = {
        page_size: -1,
        search: this.searchText || '',
        status: 'published'
      }
      this.$axios.get(`/clinics/${this.company.slug}/services`, { params })
        .then(resp => {
          this.services = []
          const results = resp?.data.results
          if (results) {
            this.services = results
          }          
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    queryChanged: debounce(function () {
      this.selectedServices = []
      this.fetchServices()
    }, 750),
    confirm () {
      this.isLoading = true
      const params = {
        products: this.selectedServices
      }
      this.$axios.patch(`/product_categories/${this.category.id}/`, params)
        .then(() => {
          this.showDialog = false
          this.$emit('assigned')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    hideDialog () {
      this.showDialog = false
      this.$emit('cancel')
    },
    createService () {
      this.$router.push('/admin/clinic/manage/service')
    }
  }
}
</script>
